import { defineStore } from 'pinia';

const ROUTER_STORAGE_KEY = 'app_router_list';

export const useRouterStore = defineStore('router', {
    state: () => ({
        currentTitle: '',
        routerList: [],
        isInitialized: false,
        error: null,
        currentPath: '/'
    }),
    getters: {
        getCurrentTitle: (state) => state.currentTitle,
        hasRouterInfo: (state) => state.routerList.length > 0
    },
    actions: {
        async fetchRouterItems() {
            this.error = null;
            const url = '/api/authorization/page';

            try {
                //const response = await ApiService.get(url);
                //const data = response.data;
                const extractedRoutes = this.extractPageItems([
                    { menu_item_url: '/', menu_item_code: 'home', menu_item_name: '회사소개', componentPath: 'system/introduce' }, // 첫 화면
                    { menu_item_url: '/system/reservation', menu_item_code: 'reservation', menu_item_name: '차량예약', componentPath: 'system/reservation-closed' }, // 렌터카 예약 준비중
                    { menu_item_url: '/system/reservation-cart', menu_item_code: 'reservation-cart', menu_item_name: '예약현황', componentPath: 'system/reservation-cart' }, // 렌터카 예약
                    // { menu_item_url: '/system/reservation-success', menu_item_code: 'reservation-success', menu_item_name: '결제성공', componentPath: 'system/reservation-success' }, // 결제성공
                    // { menu_item_url: '/system/reservation-fail', menu_item_code: 'reservation-fail', menu_item_name: '결제실패', componentPath: 'system/reservation-fail' }, // 결제실패
                    { menu_item_url: '/system/reservation-lookup', menu_item_code: 'reservation-lookup', menu_item_name: '예약조회', componentPath: 'system/reservation-lookup' }, // 예약조회
                    { menu_item_url: '/system/reservation-status', menu_item_code: 'reservation-status', menu_item_name: '예약현황', componentPath: 'system/reservation-status' }, // 예약현황
                    { menu_item_url: '/system/information', menu_item_code: 'information', menu_item_name: '이용안내', componentPath: 'system/information' }, // 이용안내
                    { menu_item_url: '/system/service', menu_item_code: 'service', menu_item_name: '고객센터', componentPath: 'system/service' }, // 고객센터
                    { menu_item_url: '/system/notice', menu_item_code: 'notice', menu_item_name: '공지사항', componentPath: 'system/notice' }, // 공지사항
                    { menu_item_url: '/system/notice-contents', menu_item_code: 'notice-contents', menu_item_name: '공지사항본문', componentPath: 'system/notice-contents' }, // 공지사항 본문
                    { menu_item_url: '/system/faq', menu_item_code: 'faq', menu_item_name: 'FAQ', componentPath: 'system/faq' }, // FAQ
                    { menu_item_url: '/system/insurance', menu_item_code: 'insurance', menu_item_name: '보험및사고처리', componentPath: 'system/insurance' }, // 보험및사고처리
                    { menu_item_url: '/system/location', menu_item_code: 'location', menu_item_name: '지점안내', componentPath: 'system/location' }, // 지점안내
                    { menu_item_url: '/system/monthly-rental', menu_item_code: 'monthly-rental', menu_item_name: '월렌트', componentPath: 'system/monthly-rental' }, // 지점안내
                    { menu_item_url: '/system/longterm-rental', menu_item_code: 'longterm-rental', menu_item_name: '장기렌트', componentPath: 'system/longterm-rental' }, // 지점안내
                    { menu_item_url: '/system/introduce', menu_item_code: 'introduce', menu_item_name: '회사소개', componentPath: 'system/introduce' }, //회사소개
                    { menu_item_url: '/login', menu_item_code: 'login', menu_item_name: '로그인', componentPath: 'login' }, //로그인
                    { menu_item_url: '/login-auth', menu_item_code: 'login-auth', menu_item_name: '로그인인증', componentPath: 'login-auth' }, //로그인인증
                    { menu_item_url: '/signup', menu_item_code: 'signup', menu_item_name: '회원가입', componentPath: 'signup' }, //회원가입
                    { menu_item_url: '/verification', menu_item_code: 'verification', menu_item_name: '본인인증', componentPath: 'verification' }, //pass본인인증
                    { menu_item_url: '/signup-normal', menu_item_code: 'signup-normal', menu_item_name: '회원가입(일반)', componentPath: 'signup-normal' }, //회원가입(일반)
                    { menu_item_url: '/signup-corp', menu_item_code: 'signup-corp', menu_item_name: '회원가입(사업자)', componentPath: 'signup-corp' }, //회원가입(사업자)
                    { menu_item_url: '/mypage', menu_item_code: 'mypage', menu_item_name: '마이페이지', componentPath: 'mypage', authCheck: true }, // 마이페이지(일반)
                    { menu_item_url: '/mypage-corp', menu_item_code: 'mypage-corp', menu_item_name: '마이페이지', componentPath: 'mypage-corp', authCheck: true }, // 마이페이지(법인)
                    { menu_item_url: '/privacytreat', menu_item_code: 'privacytreat', menu_item_name: '개인정보처리방침', componentPath: 'privacytreat' }, //개인정보처리방침
                    { menu_item_url: '/terms', menu_item_code: 'terms', menu_item_name: '이용약관', componentPath: 'terms' } //이용약관
                ]);
                //console.log(data);
                console.log(extractedRoutes);
                this.setRouterList(Array.isArray(extractedRoutes) ? extractedRoutes : []);
                this.isInitialized = true;
                return this.routerList;
            } catch (err) {
                console.error('Error Get MenuItems:', err.message);
                this.error = err.message;
                this.setRouterList([]);
                throw err;
            }
        },
        extractPageItems(items) {
            let pageItems = [];
            for (const item of items) {
                //const componentPath = item.menu_item_url === '/' ? 'reservation' : item.menu_item_url.slice(1);
                pageItems.push({
                    path: item.menu_item_url,
                    name: item.menu_item_code,
                    meta: { title: item.menu_item_name, authCheck: item.authCheck === true  },
                    componentPath: item.componentPath
                });

                if (item.children_menu_items && item.children_menu_items.length > 0) {
                    pageItems = pageItems.concat(this.extractPageItems(item.children_menu_items));
                }
            }
            return pageItems;
        },
        setRouterList(items) {
            this.routerList = items;
        },
        setCurrentTitle(title) {
            this.currentTitle = title;
        },
        setCurrentPath(path) {
            this.currentPath = path;
            localStorage.setItem('currentPath', path);
        },
        setInitialized(value) {
            this.isInitialized = value;
            if (!value) {
                this.setCurrentPath('/'); // 초기화 시 기본 경로로 설정
                localStorage.removeItem('currentPath');
            }
        },
        saveRouterListToStorage() {
            localStorage.setItem(ROUTER_STORAGE_KEY, JSON.stringify(this.routerList));
        },
        loadRouterListFromStorage() {
            const storedRouterList = localStorage.getItem(ROUTER_STORAGE_KEY);
            if (storedRouterList) {
                this.routerList = JSON.parse(storedRouterList);
                return true;
            }
            return false;
        }
    },
    persist: {
        enabled: true,
        strategies: [
            {
                key: 'router',
                storage: localStorage,
                paths: ['routerList', 'isInitialized']
            }
        ]
    }
});
